import { render, staticRenderFns } from "./SecondLevelAbout.vue?vue&type=template&id=71503f44&scoped=true"
import script from "./SecondLevelAbout.vue?vue&type=script&lang=js"
export * from "./SecondLevelAbout.vue?vue&type=script&lang=js"
import style0 from "./SecondLevelAbout.vue?vue&type=style&index=0&id=71503f44&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71503f44",
  null
  
)

export default component.exports